"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropzoneMIMEType = exports.DropzoneErrorCode = void 0;
var DropzoneErrorCode;
(function (DropzoneErrorCode) {
    DropzoneErrorCode["SpoofedFileExtension"] = "spoofed-file-extension";
    DropzoneErrorCode["FileInvalidType"] = "file-invalid-type";
    DropzoneErrorCode["FileTooLarge"] = "file-too-large";
    DropzoneErrorCode["FileTooSmall"] = "file-too-small";
    DropzoneErrorCode["TooFewFiles"] = "too-few-files";
    DropzoneErrorCode["TooManyFiles"] = "too-many-files";
    DropzoneErrorCode["CorruptedFile"] = "file-corrupted";
})(DropzoneErrorCode = exports.DropzoneErrorCode || (exports.DropzoneErrorCode = {}));
/** The supported MIME types are those that we expect to be uploadable,
 *  taken here: https://akinox.atlassian.net/browse/BGT-706 */
var DropzoneMIMEType;
(function (DropzoneMIMEType) {
    // audio
    DropzoneMIMEType["Aac"] = "audio/aac";
    DropzoneMIMEType["M4a"] = "audio/x-m4a";
    DropzoneMIMEType["Mp3"] = "audio/mpeg";
    DropzoneMIMEType["Wma"] = "audio/x-ms-wma";
    DropzoneMIMEType["Mp4a"] = "audio/mp4";
    DropzoneMIMEType["Ogg"] = "audio/ogg";
    // images
    DropzoneMIMEType["Bmp"] = "image/bmp";
    DropzoneMIMEType["Gif"] = "image/gif";
    DropzoneMIMEType["Jpeg"] = "image/jpeg";
    DropzoneMIMEType["Png"] = "image/png";
    DropzoneMIMEType["Tiff"] = "image/tiff";
    DropzoneMIMEType["Webp"] = "image/webp";
    // video
    DropzoneMIMEType["Mov"] = "video/quicktime";
    DropzoneMIMEType["Mp4"] = "video/mp4";
    DropzoneMIMEType["Wmv"] = "video/x-ms-wmv";
    DropzoneMIMEType["Webm"] = "video/webm";
    DropzoneMIMEType["Ogv"] = "video/ogg";
    // pdf
    DropzoneMIMEType["Pdf"] = "application/pdf";
    // ms
    DropzoneMIMEType["Doc"] = "application/msword";
    DropzoneMIMEType["Docx"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    DropzoneMIMEType["Xls"] = "application/vnd.ms-excel";
    DropzoneMIMEType["Xlsx"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    // other
    DropzoneMIMEType["Dcm"] = "application/dicom";
})(DropzoneMIMEType = exports.DropzoneMIMEType || (exports.DropzoneMIMEType = {}));
//# sourceMappingURL=types.js.map